<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
}
</script>

<template>
  <b-modal id="users-modal" title="Assigned Students" :hide-footer="true">
    <ul id="example-1">
      <li v-for="item in data.assigned_to" :key="item.id" class="m-2">
        {{ item.name }}
      </li>
    </ul>
  </b-modal>
</template>
